import AutosizeInput, {AutosizeInputRef} from "../../../../components/Common/AutosizeInput";
import React, {useEffect, useRef} from "react";
import * as yup from "yup";
import {IErrorClassifierErrorKeyForm} from "../../../../store/errorClassifier/types";
import {useFormik} from "formik";
import {useUpdateErrorKey} from "./hooks/useUpdateErrorKey";

interface ErrorKeyItemEditProps {
    id: number;
    value: string;
    onCancel?: () => void;
}

const ErrorKeyItemEdit: React.FC<ErrorKeyItemEditProps> = ({id, value, onCancel}) => {
    const inputRef = useRef<AutosizeInputRef>(null);
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    const {mutate: updateErrorKey} = useUpdateErrorKey(id);

    const handleSubmitForm = (values: IErrorClassifierErrorKeyForm) => {
        if (values.name === value) return;
        updateErrorKey(values);

        if (onCancel) onCancel();
    }

    const validationSchema: yup.Schema<IErrorClassifierErrorKeyForm> = yup.object().shape({
        name: yup.string()
            .min(1, "min 1 character")
            .max(75, "max 50 characters")
            .required("Key is required"),
    });

    const initialValues: IErrorClassifierErrorKeyForm = {
        name: value,
    }

    const {
        values,
        handleSubmit,
        setFieldValue,
        resetForm
    } = useFormik({
        initialValues: initialValues,
        onSubmit: handleSubmitForm,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true
    });

    const handleClick = () => {
        inputRef.current?.focus();
    }

    const handleClickOutside = (e: MouseEvent) => {
        if (buttonRef.current && !buttonRef.current.contains(e.target as Node)) {
            resetForm();

            if (onCancel) onCancel()
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleInputChange = (value: string) => setFieldValue("name", value);

    return (
        <button ref={buttonRef} className="btn btn-secondary" type="button" onClick={handleClick}>
            <form onSubmit={handleSubmit}>
                <AutosizeInput ref={inputRef} id="name" name="name" value={values.name}
                               onChange={handleInputChange}
                               initFocus/>
            </form>
        </button>
    )
}

export default ErrorKeyItemEdit